<template>
  <div class="ts-overflow-hidden">
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('attendanceGallery.dateFrom')
            }}</label>
            <DatePicker
              class="ts-w-full"
              :value="dateFrom"
              @on-change="onChangeDateFrom"
              format="dd-MM-yyyy"
              type="date"
              :class="{
                'ivu-form-item-error': errors.has('date_from')
              }"
            />
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('date_from')"
            >
              {{ errors.first('date_from') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('attendanceGallery.dateTo')
            }}</label>
            <DatePicker
              class="ts-w-full"
              :value="dateTo"
              @on-change="onChangeDateTo"
              format="dd-MM-yyyy"
              type="date"
              :class="{
                'ivu-form-item-error': errors.has('date_to')
              }"
            />
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('date_to')"
            >
              {{ errors.first('date_to') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('attendanceGallery.organisationalStructure')
            }}</label>
            <Select
              v-model="org_chart_structure_id"
              clearable
              @on-change="employee_id = null"
              :class="{
                'ivu-form-item-error': errors.has('org_chart_structure_id')
              }"
            >
              <Option
                v-for="(orgChartStructure, index) in orgChartStructures"
                :key="index"
                :value="orgChartStructure.org_chart_structure_id"
                >{{ orgChartStructure.org_chart_structure }}
              </Option>
            </Select>
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('org_chart_structure_id')"
            >
              {{ errors.first('org_chart_structure_id') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label ts-mb-2">{{
              $t('attendanceGallery.employeeName')
            }}</label>
            <Select
              v-model="employee_id"
              clearable
              multiple
              filterable
              placeholder="All"
              :loading="EmployeeLoading"
              :not-found-text="EmployeeLoading ? '' : 'No options available'"
            >
              <Option
                v-for="(employee, index) in employees"
                :key="index"
                :value="employee.employee_id"
                >{{ employee.employee_name_en }}
              </Option>
            </Select>
          </div>
          <div class="col-md-2 form-group ts-px-2 ts-pt-6">
            <ts-button
              class="ts-mb-1"
              type="primary"
              @click="fetchData"
              :waiting="loading"
              >{{ $t('view') }}
            </ts-button>
          </div>
        </div>
      </ts-panel-wrapper>
    </ts-panel>
    <div
      style="height: 75vh;"
      class="ts-overflow-y-auto ts-overflow-x-hidden ts-mt-4"
    >
      <div
        class="tab-pane fade show active"
        v-for="(items, date) in resources"
        :key="date"
      >
        <h4
          class="m-t-15 m-b-5 ts-sticky ts-top-0 ts-z-10 ts-bg-black ts-p-2 ts-rounded-sm ts-opacity-50 ts-text-white"
        >
          {{ items[0].datescan }} Photos ({{ countItems(items) }})
        </h4>

        <div class="row row-space-2">
          <div
            class="col-lg-1 col-sm-2 col-3"
            v-for="(item, index) in items"
            :key="index"
          >
            <a
              class="widget-card widget-card-rounded square m-b-2 photo-wrapper ts-relative"
              ><img
                class="widget-card-cover"
                v-lazy="{
                  src: photo(item),
                  error: onError(),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
                @click="imageView(index, items)"
              />
              <div
                class="ts-absolute ts-bottom-0 ts-w-full info-box ts-flex ts-items-end"
              >
                <h4 class="title ts-text-center" style="margin: 0 auto">
                  <b class="ts-text-xs">{{ item.name }}</b>
                  <br />
                  <b class="ts-text-xs">{{ item.timescan }}</b>
                </h4>
              </div></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import imageViewer from 'vue-image-viewer'
import Vue from 'vue'

Vue.use(imageViewer)

export default {
  name: 'attendance-detail',
  components: {},
  data () {
    return {
      errors: new Errors(),
      loading: false,
      EmployeeLoading: false,
      dateFrom: moment().format('DD-MM-YYYY'),
      dateTo: moment().format('DD-MM-YYYY'),
      org_chart_structure_id: null,
      employee_id: null,
      resources: [],
      images: []
    }
  },
  computed: {
    ...mapState('report/attendanceGallery', [
      'pagination',
      'orgChartStructures',
      'employees'
    ]),
    countItems: () => items => {
      return Object.values(items).length
    }
  },
  methods: {
    ...mapActions('report/attendanceGallery', [
      'getOrgChartStructure',
      'getEmployee',
      'clearEmployee'
    ]),
    photo (record) {
      if (record.url) {
        return `/api/files?filePath=${record.url}`
      }
      return require('@/assets/default_user.jpg')
    },
    onError (e) {
      event ? (event.target.src = require('@/assets/default_user.jpg')) : ''
    },
    imageView (index, items) {
      this.images = []
      Object.values(items).forEach(item => {
        this.images.push({
          name: item.name,
          url: `/api/files?filePath=${item.url}`
        })
        this.$imageViewer.images(this.images)
      })
      this.$imageViewer.index(parseInt(index))
      this.$imageViewer.show()
    },
    async fetchResource () {
      this.loading = true
      await this.getOrgChartStructure()
      this.org_chart_structure_id = this.orgChartStructures[0].org_chart_structure_id
      this.loading = false
    },
    async getEmployeeByOrg () {
      this.EmployeeLoading = true
      await this.clearEmployee()
      await this.getEmployee({
        id: this.org_chart_structure_id ? this.org_chart_structure_id : ''
      })
      this.EmployeeLoading = false
    },
    onChangeDateFrom (data) {
      this.dateFrom = data
    },
    onChangeDateTo (data) {
      this.dateTo = data
    },
    async fetchData (attributes) {
      this.loading = true
      this.errors = new Errors()
      this.resources = []
      this.$store
        .dispatch('report/attendanceGallery/fetch', {
          date_from: this.dateFrom,
          date_to: this.dateTo,
          org_chart_structure_id: this.org_chart_structure_id,
          employee_id: this.employee_id,
          ...attributes
        })
        .then(response => {
          this.loading = false
          this.resources = response
        })
        .catch(error => {
          this.loading = false
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'ATTENDANCES GALLERY',
        desc: not.text
      })
    }
  },
  watch: {
    org_chart_structure_id: function () {
      this.getEmployeeByOrg()
      this.fetchData()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('report/attendanceGallery/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchResource()
    })
  }
}
</script>
<style scoped lang="scss">
.photo-wrapper {
  .info-box {
    .title {
      color: #fff;
    }
    // height: 200px;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(199, 199, 199, 0.1)),
      to(rgba(0, 0, 0, 0.9))
    );
    background: linear-gradient(
      180deg,
      rgba(199, 199, 199, 0.1) 0,
      rgba(0, 0, 0, 0.9)
    );
  }
  // width: 60%;
  background: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
  -moz-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
  box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
  // padding: 3px;
  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
